<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<p style="padding-top:30%">This is a story about two young men who wanted to become great detectives, and then discovered that they had to grow up to do so. They were children thrust into a world of adults. It is also about a Great Queen whose persona looms over the ages. A Queen who was more than just a famous woman. It is not a history: persons and events have been altered to suit the needs of the narrative. As Holmes would say, “Whenever you have excluded the impossible, whatever remains, however improbable, must be the truth.”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?20d6cc2c